module.exports = __webpack_public_path__ + "static/media/image009.79253db9.jpg";